import formatCalendarDate from '../formatCalendarDate';

// iCalendar file format. See https://en.wikipedia.org/wiki/ICalendar
const createIcs = ({ startDate, endDate, location, title, description, url }) => {
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    'URL:' + url,
    'DTSTART:' + formatCalendarDate(startDate),
    'DTEND:' + formatCalendarDate(endDate),
    'SUMMARY:' + title,
    'DESCRIPTION:' + description.replace(/\n/g, '\\n'),
    'LOCATION:' + location,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\n');
};

export default createIcs;
